import { add, listen, qs, toggle, contains } from '@fluorescent/dom';
import { getSizedImageUrl } from '@shopify/theme-images';

import { default as updatePrices } from '@/lib/product/update-prices';

import { get, set } from '@fluorescent/storage';

const storage = {
  get: () => get('quick_purchase_bar'),
  set: val => set('quick_purchase_bar', val),
};

const selectors = {
  productBar: '[data-quick-purchase-bar]',
  purchaseButton: '[data-quick-purchase-button]',
  hideButton: '[data-mobile-hide]',
  productForm: '.product-form',
  productTop: '.product__top',
  productImage: '.quick-purchase-bar__product-image',
  barQuantity: '[data-bar-quantity]',
  barProductTitle: '[data-bar-product-title]',
};

const classes = {
  active: 'active',
  loading: 'loading',
  hidden: 'is-hidden',
};

export default function (container, variant) {
  const productForm = qs(selectors.productForm, container);
  const productBar = qs(selectors.productBar, container);
  const purchaseButton = qs(selectors.purchaseButton, container);
  const hideButton = qs(selectors.hideButton, container);
  const productImage = qs(selectors.productImage, container);
  const barQuantity = qs(selectors.barQuantity, container);
  const barProductTitle = qs(selectors.barProductTitle, container);
  const productQuantity = qs('input[name="quantity"]', container);
  const variantSelector = qs('#variant-selector', container);

  barQuantity.innerHTML = `x ${parseInt(productQuantity.value, 10)}`;
  barProductTitle.innerHTML = variant.name;

  let observer = null;

  setOffset();

  if (storage.get()) {
    add(productBar, classes.hidden);
  }

  // Preload the quick buy button with currently selected variant
  preloadBuyButton(variantSelector.value, productQuantity.value);

  const events = [
    listen(purchaseButton, 'click', e => {
      e.preventDefault();
    }),
    listen(hideButton, 'click', e => {
      setOffset();
      toggle(productBar, classes.hidden);
      storage.set(contains(productBar, classes.hidden));
    }),
  ];

  if (window.matchMedia('(min-width: 60em)').matches) {
    _intObserver();
  } else {
    setTimeout(() => {
      add(productBar, classes.active);
    }, 1000);
  }

  function setOffset() {
    productBar.style.setProperty(
      '--quick-purchase-offset',
      `${productBar.clientHeight - 20}px`
    );
  }

  function _intObserver() {
    observer = new IntersectionObserver(([{ isIntersecting: visible }]) => {
      toggle(productBar, classes.active, !visible);
    });
    observer.observe(productForm);
  }

  function preloadBuyButton(variantId, quantity) {
    purchaseButton.href = `${window.theme.routes.cart.base}/${variantId}:${quantity}`;
  }

  function update(variant) {
    // if the variant is not available do not update to a sold out product
    if (!variant.available) return;

    preloadBuyButton(variant.id, productQuantity.value);
    updatePrices(productBar, variant);

    barQuantity.innerHTML = '';
    barProductTitle.innerHTML = '';

    barQuantity.innerHTML = `x ${parseInt(productQuantity.value, 10)}`;
    barProductTitle.innerHTML = variant.name;

    if (variant.featured_media) {
      const img = `<img class="image__img lazyload" data-src="${getSizedImageUrl(
        variant.featured_media.preview_image.src,
        '120x'
      )}" />`;

      productImage.innerHTML = img;
    }
  }

  const unload = () => {
    observer && observer.disconnect();
    events.forEach(unsubscribe => unsubscribe());
  };

  return { update, unload };
}
